import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BlockSeparator } from '../../../../models/BlockSettings';
import ColorPicker from '../../../Pickers/ColorPicker/ColorPicker';

interface BlockSeparatorPickerProps {
  value: BlockSeparator;
  color: string;
  onChangeSeparator: (value: BlockSeparator) => void;
  onChangeSeparatorColor: (color: string) => void;
}

const BlockSeparatorPicker = ({
  value,
  color,
  onChangeSeparator,
  onChangeSeparatorColor,
}: BlockSeparatorPickerProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <Box>
      Separator

      <ToggleButtonGroup
        color="primary"
        value={value}
        exclusive
        onChange={(_, newValue: BlockSeparator) => {
          if (newValue) {
            onChangeSeparator(newValue);
          }
        }}
        size="small"
        sx={{ marginLeft: 3 }}
      >
        <ToggleButton value={BlockSeparator.SLASH} sx={{ paddingX: 2, paddingY: 1 }}>Slash</ToggleButton>
        <ToggleButton value={BlockSeparator.PIPE} sx={{ paddingX: 2, paddingY: 1 }}>Pipe</ToggleButton>
        <ToggleButton value={BlockSeparator.NONE} sx={{ paddingX: 2, paddingY: 1 }}>None</ToggleButton>
      </ToggleButtonGroup>
    </Box>

    <Box>
      Separator Color

      <ColorPicker
        value={color}
        onPickColor={(newColor) => {
          onChangeSeparatorColor(newColor);
        }}
      />
    </Box>
  </Box>
);

export default BlockSeparatorPicker;
